// groupAgents.constants.js
// Group and Agent specific constants for PAIC module

export const DOCUMENT_TYPE_OPTIONS = [
  // Bug #1871: "New Org Design" and "Agent Architecture" have no destination yet
  // (handleDocumentTypeChange has no case for them), so selecting them was a dead
  // end. Disabled/grayed out until those views are wired up.
  { value: "org-design", label: "New Org Design", disabled: true },
  { value: "agent-architecture", label: "Agent Architecture", disabled: true },
  { value: "agent-jd", label: "Agent Job Descriptions" },
  { value: "people-jd", label: "People (+AI) Job Descriptions" },
  { value: "agent-prd", label: "Product Requirement Documents" },
];

export const GROUP_AGENT_TABS = [
  { key: "jd", label: "Jobs Library" },
  { key: "skills-bridger", label: "Skills Bridger" },
  { key: "people-plus-ai", label: "People + AI" },
  { key: "learning-catalyst", label: "Learning Catalyst" },
  { key: "talent-mobility", label: "Talent Mobility" },
];

export const PEOPLE_PLUS_AI_DROPDOWN_OPTIONS = [
  { key: "for-group", label: "For Group" },
  { key: "for-role", label: "For Role" },
];

// Aliases for backward compatibility
export const GROUP_DETAIL_TABS = GROUP_AGENT_TABS;
export const PEOPLE_PLUS_AI_MENU_ITEMS = PEOPLE_PLUS_AI_DROPDOWN_OPTIONS;
